const NON_PROD_HOSTS = new Set([
    'qa.cms.chaika.com',
    'dev.cms.chaika.com',
    'localhost',
    'chaika.qa.astrahealth.tech',
    'chaika.development.astrahealth.tech',
]);

const REVIEW_HOST_SUFFIX = '.review.cms.chaika.com';

export function isNonProdEnv(
    hostname: string = typeof window === 'undefined' ? '' : (window.location?.hostname ?? ''),
): boolean {
    return NON_PROD_HOSTS.has(hostname) || hostname.endsWith(REVIEW_HOST_SUFFIX);
}
